import {poolsConfig, boostersConfig, zapInsConfig, farmsConfig} from '~/config/constants'
import {chainTokens} from '~/config/constants/tokens'

// Addresses
import {
  getAddress,
  getMasterChefAddress,
  getCakeVaultAddress,
  getChainlinkOracleAddress,
  getMulticallAddress,
  getFairlaunchAddress,
  getFarmZapAddress,
  getNftMarketAddress, getFeeManagerAddress,
  // getLiquidityAmountsAddress,
  // getLbVaultNativeAddress,
  // getStrategyAddress,
  // getLBLimitOrderManagerAddress
} from '~/utils/addressHelpers'

// ABI
import {ChainId} from '@pancakeswap/sdk'
import {CHAIN_ID} from '~/config/constants/chains'
import {Abi, Address, WalletClient, PublicClient, getContract as viemGetContract} from 'viem'
import {viemClients} from './viem'
import {masterchefABI} from '~/config/abi/masterchef'
import {zapInABI} from '~/config/abi/zapIn'
import {fairlaunchERC20ABI} from '~/config/abi/fairlaunchERC20'
import {lpTokenABI} from '~/config/abi/lpToken'
import {ifoV1ABI} from '~/config/abi/ifoV1'
import {ifoV2ABI} from '~/config/abi/ifoV2'
import {erc20ABI, erc721ABI} from 'wagmi'
import {LB_FACTORY_V21_ADDRESS} from "~/v3sdk/constants";
// import {farmZapABI} from "~/config/abi/farmAuction";
import {boosterABI} from "~/config/abi/booster";
import {rewardPoolABI} from "~/config/abi/rewardPool";
import {rewarderABI} from "~/config/abi/rewarder";
import {LBFactoryV21ABI, LBPairABI, LBPairV21ABI} from "~/v3sdk";
// import {lbVaultNativeABI} from "~/config/abi/lbVaultNative";
// import {oracleVaultABI} from "~/config/abi/oracleVault";
// import {lbLimitOrderManagerABI} from "~/config/abi/lbLimitOrderManager";
import {nftMarketABI} from "~/config/abi/nftMarket";
// import {liquidityAmountsABI} from "~/config/abi/liquidityAmounts";
import {cakeABI} from "~/config/abi/cake";
import {cakeVaultABI} from "~/config/abi/cakeVault";
// import {strategyABI} from "~/config/abi/strategy";
import {ifoLinearABI} from "~/config/abi/ifoLinear";
import {chainlinkOracleABI} from "~/config/abi/chainlinkOracle";
import {ChainLinkOracleContract} from "~/utils/types";
import {MulticallABI} from "~/config/abi/Multicall";
import {ifoABI} from "~/config/abi/ifo";
import {feeManagerABI} from "~/config/abi/feeManager";
// import {lbPairV21ABI} from '~/v3sdk/abis/LBPairV21'
// import {lbPairABI} from '~/v3sdk/abis/LBPair'

export const getContract = <TAbi extends Abi | unknown[], TWalletClient extends WalletClient>({
                                                                                                abi,
                                                                                                address,
                                                                                                chainId = CHAIN_ID.SHIMMER,
                                                                                                publicClient,
                                                                                                signer,
                                                                                              }: {
  abi: TAbi
  address: Address
  chainId?: ChainId
  signer?: TWalletClient
  publicClient?: PublicClient
}) => {
  const c = viemGetContract({
    abi,
    address,
    publicClient: publicClient ?? viemClients[chainId],
    walletClient: signer,
  })
  return {
    ...c,
    account: signer?.account,
    chain: signer?.chain,
  }
}

export const getBep20Contract = (chainId, address: Address, signer?: WalletClient) => {
  return getContract({chainId, address, abi: erc20ABI, signer})
}
export const getErc20Contract = (chainId, address: Address, signer?: WalletClient) => {
  return getContract({chainId, address, abi: erc20ABI, signer})
}
export const getErc721Contract = (chainId, address: Address, signer?: WalletClient) => {
  return getContract({chainId, abi: erc721ABI, address, signer})
}
export const getLpContract = (chainId, address: Address, signer?: WalletClient) => {
  return getContract({chainId, abi: lpTokenABI, address, signer})
}
export const getIfoV1Contract = (chainId, address: Address, signer?: WalletClient) => {
  return getContract({chainId, abi: ifoV1ABI, address, signer})
}
export const getIfoV2Contract = (chainId, address: Address, signer?: WalletClient) => {
  return getContract({chainId, abi: ifoV2ABI, address, signer})
}
// export const getRouterContract = (chainId, address: Address, signer?: WalletClient) => {
//   return getContract({chainId, abi: routerABI, address, signer})
// }
export const getSouschefContract = (chainId: number, id: number, signer?: WalletClient) => {
  const config = poolsConfig[chainId].find((pool) => pool.sousId === id)
  // const abi = config.poolCategory === PoolCategory.BINANCE ? sousChefBnb : sousChef
  return getContract({
    chainId,
    abi: rewardPoolABI,
    address: getAddress(chainId, config.contractAddress) as Address,
    signer
  })
}
export const getSouschefV2Contract = (chainId: number, id: number, signer?: WalletClient) => {
  const config = poolsConfig[chainId].find((pool) => pool.sousId === id)
  // return getContract(sousChefV2, getAddress(config.contractAddress), signer)
  return getContract({
    chainId,
    abi: rewardPoolABI,
    address: getAddress(chainId, config.contractAddress) as Address,
    signer
  })
}
export const getBoosterContract = (chainId: number, id: number, signer?: WalletClient) => {
  const config = boostersConfig[chainId].find((pool) => pool.sousId === id)
  return getContract({
    chainId,
    abi: boosterABI,
    address: getAddress(chainId, config.contractAddress) as Address,
    signer
  });
}
export const getZapInContract = (chainId: number, signer?: WalletClient) => {
  const config = zapInsConfig[0]
  return getContract({chainId, abi: zapInABI, address: getAddress(chainId, config.contractAddress) as Address, signer});
}
// export const getDualRewardsPoolContract = (chainId: number, signer?: WalletClient) => {
//   const config = lockedLumConfigs[chainId]
//   return getContract({chainId, abi: dualRewardPoolABI, address: getAddress(chainId, config.contractAddress) as Address, signer});
// }
// export const getFarmZapContract = (chainId: number, signer?: WalletClient) => {
//   return getContract({chainId, abi: farmZapABI, address: getFarmZapAddress(chainId) as Address, signer});
// }
export const getRewarderContract = (chainId: number, id: number, signer?: WalletClient) => {
  const config = farmsConfig[chainId].find((farm) => farm.pid === id)
  return getContract({chainId, abi: rewarderABI, address: getAddress(chainId, config.rewarder) as Address, signer});
}
export const getFairlaunchContract = (chainId: number, signer?: WalletClient) => {
  return getContract({chainId, abi: fairlaunchERC20ABI, address: getFairlaunchAddress(chainId) as Address, signer});
}
// export const getLBVaultNativeContract = (chainId: number, contractAddress: string, signer?: WalletClient) => {
//   return getContract({chainId, abi: lbVaultNativeABI, address: contractAddress as Address, signer});
// }
// export const getOracleVaultContract = (chainId: number, contractAddress: string, signer?: WalletClient) => {
//   return getContract({chainId, abi: oracleVaultABI, address: contractAddress as Address, signer});
// }
// export const getLBLimitOrderManagerContract = (chainId: number, signer?: WalletClient) => {
//   return getContract({
//     chainId,
//     abi: lbLimitOrderManagerABI,
//     address: getLBLimitOrderManagerAddress(chainId) as Address,
//     signer
//   });
// }

export const getLBFactoryV21 = (chainId: number, signer?: WalletClient) => {
  return getContract({chainId, abi: LBFactoryV21ABI, address: LB_FACTORY_V21_ADDRESS[chainId] as Address, signer})
}

// /**
//  * @deprecated
//  * @param chainId
//  * @param signer
//  * @returns
//  */
// export const getStrategyContract = (chainId: number, signer?: WalletClient) => {
//   return getContract({chainId, abi: strategyABI, address: getStrategyAddress(chainId) as Address, signer});
// }

// export const getLBStrategyContract = (chainId: number, address: Address, signer?: WalletClient) => {
//   return getContract({chainId, abi: strategyABI, address, signer});
// }


export const getIfoContract = (chainId: number, address: Address, signer?: WalletClient) => {
  return getContract({chainId, abi: ifoABI, address, signer});
}

export const getIfoLinearContract = (chainId: number, address: Address, signer?: WalletClient) => {
  return getContract({chainId, abi: ifoLinearABI, address, signer});
}

export const getCakeContract = (chainId: number, signer?: WalletClient) => {
  return getContract({chainId, abi: cakeABI, address: chainTokens.lum.address[chainId], signer})
}

export const getGoldenPearlContrat = (chainId: number, signer?: WalletClient) => {
  return getContract({chainId, abi: cakeABI, address: chainTokens.magicLum.address[chainId], signer})
}

export const getMasterchefContract = (chainId: number, signer?: WalletClient) => {
  return getContract({chainId, abi: masterchefABI, address: getMasterChefAddress(chainId) as Address, signer})
}
export const getFeeManager = (chainId: number, signer?: WalletClient) => {
  return getContract({chainId, abi: feeManagerABI, address: getFeeManagerAddress(chainId) as Address, signer})
}
export const getCakeVaultContract = (chainId: number, signer?: WalletClient) => {
  return getContract({chainId, abi: cakeVaultABI, address: getCakeVaultAddress(chainId) as Address, signer})
}

export const getChainlinkOracleContract = (chainId: number, signer?: WalletClient) => {
  return getContract({
    chainId,
    abi: chainlinkOracleABI,
    address: getChainlinkOracleAddress(chainId) as Address,
    signer
  })
}
export const getMulticallContract = (chainId: number, signer?: WalletClient) => {
  return getContract({chainId, abi: MulticallABI, address: getMulticallAddress(chainId) as Address, signer})
}

export const getNftMarketContract = (chainId: number, signer?: WalletClient) => {
  return getContract({chainId, abi: nftMarketABI, address: getNftMarketAddress(chainId) as Address, signer})
}

// export const getLiquidityAmountsContract = (chainId: number, signer?: WalletClient) => {
//   return getContract({
//     chainId,
//     abi: liquidityAmountsABI,
//     address: getLiquidityAmountsAddress(chainId) as Address,
//     signer
//   })
// }

// export const getLBPairContract = (chainId: number, address: Address, isV21: boolean, signer?: WalletClient) => {
//   return getContract({
//     chainId,
//     abi: isV21 ? lbPairV21ABI : lbPairABI,
//     address,
//     signer
//   })
// }
